import React, {
  useEffect,
  useState,
  useContext,
  useImperativeHandle,
  useRef,
  forwardRef
} from 'react';
import {
  getTranslatedText,
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  AppContext,
  DATE_TIME_FORMAT,
  EventEmitter,
  EventEmitterWithIndex,
  getDateTimeFormat,
  generateString,
  validateForm,
  segmentTimerConstraints,
  segmentWorklogConstraints,
  reactSelectInlineError,
  getParsedCrudData,
  TEXT_LENGTH,
  getDifference,
  DeleteModal,
  sendMessageToContentJS,
  DATE_FORMAT,
  AccessControl,
  COMMON_CONSTANTS,
  useCheckFeatureGating,
  AI_AGENTS_CONSTANT_FEATURE_ID_MAP
} from '@nile/components';
import {
  Dropdown,
  Avatar,
  ButtonGroup,
  Button,
  DateTimePicker,
  TextField,
  Checkbox,
  DisplayText,
  TextStyle,
  Link
} from '@superops/ui-design-system';
import { cloneDeep, isEmpty, isEqual, omit, pick } from 'lodash';
import { SVGIcon } from '@superops/super-icons';
import { injectIntl, FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';
import dayjs from 'dayjs';
import { validate } from 'validate.js';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import {
  DataGetter,
  Wrapper,
  IconHolder,
  DateWrapper,
  TimeCollector
} from './utils';
import { BlockItemConsumptionInfo } from './BlockItemConsumptionInfo';
import AssociateWorkItem from './AssociateWorkItem';
import DurationDropdown from '@nile/components/src/Dropdowns/DurationDropdown';
import TimeSelectionDropdown from '@nile/components/src/Dropdowns/TimeSelectionDropdown';
import { SizeMe } from 'react-sizeme';
import WorklogTask from './WorklogTask';
import { AIOnboardingRatingComponent } from '@nile/components';

function ErrorFallback({ error, resetErrorBoundary }) {
  return <div>Error...</div>;
}

function WorklogManualTimerForm(props) {
  const {
    timer,
    intl,
    editMode,
    options,
    selectedItem,
    itemsForTimeTrackingLoading,
    currentUser,
    comments,
    billable,
    afterHours,
    billDateTime,
    qty,
    handlePropChange,
    addWorklogEntry,
    createWorklogEntry,
    createWorklogEntryFromTimerLoading,
    updateWorklogEntry,
    addWorklogLoading,
    createWorklogLoading,
    updateWorklogLoading,
    resetWorklogEntry,
    module = null,
    workItem,
    itemId,
    mode,
    handleClose,
    associateWorkItem,
    associatedWorkItem,
    reAssociateWorkItem,
    handleAssociateWorkItem,
    workLogEdit,
    createWorklogTimerEntry,
    updateWorklogTimerEntry,
    deleteWorklogTimerEntry,
    createWorklogTimerEntryLoading,
    updateWorklogTimerEntryLoading,
    deleteWorklogTimerEntryLoading,
    createWorklogEntryFromTimer,
    deleteWorklogEntry,
    deleteWorklogEntryLoading,
    forwardedRef,
    hideCancel,
    hideWorkitem,
    hideDelete,
    handleParentClose,
    worklogAdd,
    globaltimerSection,
    repositionPopup,
    closeOnCancel,
    aiGeneratedNote,
    setAIgeneratedNote,
    timerNote,
    isAgentChat = false,
    disableSaveTimer = false,
    taskId,
    hideWorklogTask,
    hideTaskWorkItem,
    taskViewOnly,
    hideBlockItemConsumptionInfo
  } = props;
  const homeContext = useContext(HomeContext);
  const [errors, setErrors] = useState(null);
  const [showAiNote, setShowAiNote] = useState(isAgentChat);
  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const [segments, setSegments] = useState(
    !isEmpty(props?.segments)
      ? props?.segments
      : [
          workLogEdit
            ? {
                segmentId: `${generateString(5)}`,
                event: {
                  startTime: null,
                  endTime: dayjs(new Date()).format(DATE_TIME_FORMAT)
                },
                timespent: '',
                afterHours: false
              }
            : {
                segmentId: `${generateString(5)}`,
                startTime: null,
                endTime: dayjs(new Date()).format(DATE_TIME_FORMAT),
                timespent: '',
                afterHours: false
              }
        ]
  );

  const flags = useFlags();
  let updateTimer = null;
  const associatedTaskToTimer = !isEmpty(timer?.task) ? timer?.task : null;

  const handlePropertyChange = (property, value) => {
    handlePropChange(property, value);
  };

  const handleBillable = () => {
    // if (selectedItem) {
    handlePropertyChange('billable', !billable);
    // }
  };

  const validateTimer = () => {
    const result = validate(
      { notes: comments, segments: segments },
      {
        notes: {
          type: 'string',
          presence: {
            allowEmpty: false
          }
        },
        ...segmentTimerConstraints
      }
    );

    return result;
  };

  const handleTimerClick = () => {
    const validationResult = validateTimer();
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);

    if (createWorklogTimerEntryLoading || updateWorklogTimerEntryLoading)
      return;

    let inputObj = {
      billable,
      notes: comments,
      type: 'MANUAL',
      workItem: workItem
        ? {
            workId: workItem?.workId,
            module: workItem?.module || module
          }
        : null
    };
    if (selectedItem) {
      inputObj = {
        ...inputObj,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
          itemId: selectedItem?.itemId
        }
      };
    }

    if (!timer?.timerId) {
      if (taskId) {
        inputObj.task = {
          taskId: taskId
        };
      }
      createWorklogTimerEntry({
        variables: {
          timerEntryInput: {
            addSegments: segments.map((segment) => {
              return {
                afterHours: segment?.afterHours,
                startTime: segment?.startTime,
                endTime: segment?.endTime,
                timespent: parseFloat(segment?.timespent / 60).toFixed(2)
              };
            }),
            ...inputObj
          }
        }
      }).then((res) => {
        resetWorklogEntry();
      });
    } else {
      if (timer?.type === 'AUTOMATIC') {
        inputObj.addSegments = segments.map((segment) => {
          return {
            ...omit(segment, ['segmentId', 'segmentDate']),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
      } else {
        const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
          props?.segments,
          segments,
          'segmentId'
        );
        inputObj.addSegments = addedItems.map((segment) => {
          return {
            ...omit(segment, ['segmentId', 'segmentDate']),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
        inputObj.updateSegments = updatedItems.map((segment) => {
          return {
            ...omit(segment, 'segmentDate'),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
        inputObj.deleteSegments = deletedItems.map((segment) => {
          return pick(segment, 'segmentId');
        });
      }

      updateWorklogTimerEntry({
        variables: {
          timerEntryInput: {
            timerId: timer?.timerId,
            running: false,
            ...inputObj
          }
        }
      }).then((res) => {
        if (!editMode) resetWorklog();
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');
      });
    }
  };

  const handleAddWorklog = () => {
    const clonedSegments = cloneDeep(segments);
    const constraints = workLogEdit
      ? segmentWorklogConstraints
      : segmentTimerConstraints;
    const validationResult = validate(
      { notes: comments, segments: clonedSegments },
      {
        notes: {
          type: 'string',
          presence: {
            allowEmpty: false
          }
        },
        ...constraints
      }
    );
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);

    let inputObj = {
      [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: selectedItem
        ? {
            itemId: selectedItem?.itemId
          }
        : null,
      billable,
      // afterHours: timer?.afterHours,
      billDateTime,
      notes: comments
    };

    if (taskId) {
      inputObj.task = {
        taskId: taskId
      };
    }
    if (workLogEdit) {
      const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
        props?.segments,
        segments,
        'segmentId'
      );

      updateWorklogEntry({
        variables: {
          updateWorklogEntryInput: {
            ...inputObj,
            itemId: itemId,
            afterHours: afterHours,
            addSegments: addedItems.map((segment) => {
              return {
                timespent: parseFloat(segment?.timespent / 60).toFixed(2),
                event: {
                  startTime: segment?.event?.startTime,
                  endTime: segment?.event?.endTime
                }
              };
            }),
            updateSegments: updatedItems.map((segment) => {
              return {
                segmentId: segment?.segmentId,
                timespent: parseFloat(segment?.timespent / 60).toFixed(2),
                event: {
                  startTime: segment?.event?.startTime,
                  endTime: segment?.event?.endTime
                }
              };
            }),
            deleteSegments: deletedItems.map((segment) => {
              return pick(segment, 'segmentId');
            })
          }
        }
      });
    } else if (editMode && timer?.timerId) {
      const timerEntryInput = {
        timerId: timer?.timerId,
        billable: billable,
        notes: comments,
        type: 'MANUAL',
        workItem: workItem
          ? {
              workId: workItem?.workId,
              module: workItem?.module || module
            }
          : null,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: selectedItem
          ? {
              itemId: selectedItem?.itemId
            }
          : null
      };

      const timerDataChanged = getDifference(
        { ...timerEntryInput, segments: segments },
        pick(timer, [
          'timerId',
          'billable',
          'notes',
          'type',
          'segments',
          'workItem.workId',
          'workItem.module',
          'serviceItem.itemId',
          'serviceCatalogItem.itemId'
        ])
      );

      if (timer?.type === 'AUTOMATIC') {
        timerEntryInput.addSegments = segments.map((segment) => {
          return {
            ...omit(segment, ['segmentId', 'segmentDate']),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
      } else {
        const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
          props?.segments,
          segments,
          'segmentId'
        );
        timerEntryInput.addSegments = addedItems.map((segment) => {
          return {
            ...omit(segment, ['segmentId', 'segmentDate']),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
        timerEntryInput.updateSegments = updatedItems.map((segment) => {
          return {
            ...omit(segment, 'segmentDate'),
            timespent: parseFloat(segment?.timespent / 60).toFixed(2)
          };
        });
        timerEntryInput.deleteSegments = deletedItems.map((segment) => {
          return pick(segment, 'segmentId');
        });
      }

      if (!isEmpty(timerDataChanged)) {
        updateWorklogTimerEntry({
          variables: {
            timerEntryInput: timerEntryInput
          }
        }).then((res) => {
          createWorklogEntryFromTimer({
            variables: {
              input: [
                {
                  timerId: timer.timerId
                }
              ]
            }
          });
        });
      } else {
        createWorklogEntryFromTimer({
          variables: {
            input: [
              {
                timerId: timer.timerId
              }
            ]
          }
        });
      }
    } else {
      const afterHourSegments = segments.filter((segmnt) => {
        return segmnt.afterHours;
      });
      const workingHourSegments = segments.filter((segmnt) => {
        return !segmnt.afterHours;
      });
      let entries = [];
      if (afterHourSegments.length) {
        entries = [
          ...entries,
          {
            ...inputObj,
            workItem: workItem
              ? {
                  workId: workItem?.workId,
                  module: workItem?.module || module
                }
              : null,
            afterHours: true,
            addSegments: afterHourSegments.map((segment) => {
              return {
                timespent: parseFloat(segment?.timespent / 60).toFixed(2),
                event: {
                  startTime: segment?.event?.startTime || segment?.startTime,
                  endTime: segment?.event?.endTime || segment?.endTime
                }
              };
            })
          }
        ];
      }
      if (workingHourSegments.length) {
        entries = [
          ...entries,
          {
            ...inputObj,
            workItem: workItem
              ? {
                  workId: workItem?.workId,
                  module: workItem?.module || module
                }
              : null,
            afterHours: false,
            addSegments: workingHourSegments.map((segment) => {
              return {
                timespent: parseFloat(segment?.timespent / 60).toFixed(2),
                event: {
                  startTime: segment?.event?.startTime || segment?.startTime,
                  endTime: segment?.event?.endTime || segment?.endTime
                }
              };
            })
          }
        ];
      }

      const input = {
        entries: entries
      };

      if (timer?.timerId) {
        input.timer = { timerId: timer?.timerId };
      }

      addWorklogEntry({
        variables: {
          input: input
        }
      });
    }
  };

  const handleCreateWorkLog = (workItemData) => {
    createWorklogEntry({
      variables: {
        createWorklogEntryInput: [
          {
            [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: selectedItem
              ? {
                  itemId: selectedItem?.itemId
                }
              : null,
            billable,
            // afterHours,
            qty: qty ? qty.toString() : '0',

            billDateTime,
            notes: comments,
            module,
            workItem: workItemData
              ? {
                  workId: workItemData?.workId || workItemData?.ticketId,
                  module: workItemData?.module || module
                }
              : null,
            addSegments: segments.map((segment) => {
              return {
                timespent: segment?.timespent,
                event: {
                  startTime: segment?.startTime,
                  endTime: segment?.endTime
                }
              };
            })
          }
        ]
      }
    }).then((res) => {
      EventEmitterWithIndex.dispatch('refetchWorklogs');
      homeContext.closeCurrentTab();

      window.setTimeout(() => {
        homeContext.openTab({
          module: 'TICKET',
          data: {
            subject: workItemData?.subject,
            displayId: workItemData?.displayId,
            ticketId: workItemData?.ticketId
          },
          ticketId: workItemData?.ticketId
        });
      }, 500);
    });
  };

  const handleNewTicketCreation = (timerData, workItemData) => {
    if (isEmpty(timerData?.serviceCatalogItem)) {
      homeContext.closeCurrentTab();
      window.setTimeout(() => {
        homeContext.createTab({
          module: 'TICKET',
          data: {
            subject: workItemData?.subject,
            displayId: workItemData?.displayId,
            ticketId: workItemData?.ticketId
          },
          ticketId: workItemData?.ticketId
        });
      }, 500);
    } else {
      createWorklogEntryFromTimer({
        variables: {
          input: [
            {
              timerId: timerData.timerId
            }
          ]
        }
      }).then((resp) => {
        if (resp) {
          homeContext.closeCurrentTab();
          window.setTimeout(() => {
            homeContext.openTab({
              module: 'TICKET',
              data: {
                subject: workItemData?.subject,
                displayId: workItemData?.displayId,
                ticketId: workItemData?.ticketId
              },
              ticketId: workItemData?.ticketId
            });
          }, 500);
        }
      });
    }
  };

  const handleCreateWorkLogFromCreateTicket = (workItemData) => {
    const { timerId, running } = timer;
    const validationResult = validateTimer();
    if (running && validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);

    const workItemObj = workItemData || workItem;

    let inputObj = {
      billable,
      notes: comments,
      type: 'MANUAL',
      workItem:
        workItemObj?.workId || workItemObj?.ticketId
          ? {
              workId: workItemObj?.workId || workItemObj?.ticketId,
              module: workItemObj?.module || 'TICKET'
            }
          : null
    };
    if (selectedItem) {
      inputObj = {
        ...inputObj,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
          itemId: selectedItem?.itemId
        }
      };
    }
    if (taskId) {
      inputObj.task = {
        taskId: taskId
      };
    }

    if (createWorklogTimerEntryLoading || updateWorklogTimerEntryLoading)
      return;
    if (!timerId) {
      createWorklogTimerEntry({
        variables: {
          timerEntryInput: {
            addSegments: segments.map((segment) => {
              return {
                ...omit(segment, ['segmentDate']),
                timespent: parseFloat(segment?.timespent / 60).toFixed(2)
              };
            }),
            ...inputObj
          }
        }
      }).then((res) => {
        if (res?.data?.createWorklogTimerEntry) {
          handleNewTicketCreation(
            res?.data?.createWorklogTimerEntry,
            workItemObj
          );
        }
      });
    } else {
      const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
        props?.segments,
        segments,
        'segmentId'
      );
      updateWorklogTimerEntry({
        variables: {
          timerEntryInput: {
            ...inputObj,
            timerId,
            addSegments: addedItems.map((segment) => {
              return {
                afterHours: segment?.afterHours,
                startTime: segment?.startTime,
                endTime: segment?.endTime,
                timespent: parseFloat(segment?.timespent / 60).toFixed(2)
              };
            }),
            updateSegments: updatedItems.map((segment) => {
              return {
                ...omit(segment, 'segmentDate'),
                timespent: parseFloat(segment?.timespent / 60).toFixed(2)
              };
            }),
            deleteSegments: deletedItems.map((segment) => {
              return pick(segment, 'segmentId');
            })
          }
        }
      }).then((res) => {
        if (res?.data?.updateWorklogTimerEntry) {
          handleNewTicketCreation(
            res?.data?.updateWorklogTimerEntry,
            workItemObj
          );
        }
      });
    }
  };

  useImperativeHandle(forwardedRef, () => {
    let inputObj = {
      billable,
      notes: comments,
      type: 'MANUAL',
      timerId: timer?.timerId
    };
    if (selectedItem) {
      inputObj = {
        ...inputObj,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
          itemId: selectedItem?.itemId
        }
      };
    }
    if (taskId) {
      inputObj.task = {
        taskId: taskId
      };
    }

    if (timer?.type === 'AUTOMATIC') {
      inputObj.addSegments = segments.map((segment) => {
        return {
          afterHours: segment?.afterHours,
          startTime: segment?.startTime,
          endTime: segment?.endTime,
          timespent: parseFloat(segment?.timespent / 60).toFixed(2)
        };
      });
    } else {
      const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
        props?.segments,
        segments,
        'segmentId'
      );
      inputObj.addSegments = addedItems.map((segment) => {
        return {
          ...omit(segment, ['segmentDate']),
          timespent: parseFloat(segment?.timespent / 60).toFixed(2)
        };
      });
      inputObj.updateSegments = updatedItems.map((segment) => {
        return {
          ...omit(segment, ['segmentDate']),
          timespent: parseFloat(segment?.timespent / 60).toFixed(2)
        };
      });
      inputObj.deleteSegments = deletedItems.map((segment) => {
        return pick(segment, 'segmentId');
      });
    }
    return {
      getTimerInputObj: inputObj
    };
  });

  useEffect(() => {
    EventEmitter.subscribe(
      'createWorkLogFromCreateTicket',
      handleCreateWorkLogFromCreateTicket
    );
    return function cleanup() {
      EventEmitter.unsubscribe('createWorkLogFromCreateTicket');
    };
  });

  useEffect(() => {
    if (!isEmpty(props?.segments)) {
      setSegments(props?.segments);
    } else {
      setSegments([
        {
          segmentId: `${generateString(5)}`,
          startTime: null,
          endTime: dayjs(new Date()).format(DATE_TIME_FORMAT),
          timespent: '',
          afterHours: false
        }
      ]);
    }
  }, [props?.segments]);

  const resetWorklog = () => {
    resetWorklogEntry();
    if (handleClose && !props?.disableCloseOnSuccess) {
      handleClose();
    }
  };

  function validateSegments(segmentsToValidate) {
    const validationResult = validateForm(
      { segments: segmentsToValidate },
      workLogEdit ? segmentWorklogConstraints : segmentTimerConstraints
    );
    if (validationResult) {
      setErrors(validationResult);
    } else {
      setErrors(null);
    }
    return validationResult;
  }

  const addSegment = (callback) => {
    const clonedSegments = cloneDeep(segments);
    const isNotValid = validateSegments(clonedSegments);
    const lastAddedSegment = clonedSegments[clonedSegments.length - 1];
    if (!isNotValid) {
      const newSegment = workLogEdit
        ? {
            segmentId: `${generateString(5)}`,
            event: {
              startTime: null,
              endTime: lastAddedSegment
                ? dayjs(lastAddedSegment?.endTime)
                    .set('hours', dayjs().get('hours'))
                    .set('minutes', dayjs().get('minutes'))
                    .format(DATE_TIME_FORMAT)
                : null
            },
            timespent: '',
            afterHours: false
          }
        : {
            segmentId: `${generateString(5)}`,
            startTime: null,
            endTime: lastAddedSegment
              ? dayjs(lastAddedSegment?.endTime)
                  .set('hours', dayjs().get('hours'))
                  .set('minutes', dayjs().get('minutes'))
                  .format(DATE_TIME_FORMAT)
              : null,
            timespent: '',
            afterHours: false
          };
      clonedSegments.push(newSegment);
      setSegments(clonedSegments);
      if (repositionPopup) {
        if (updateTimer) clearTimeout(updateTimer);
        updateTimer = setTimeout(() => {
          repositionPopup();
        }, 800);
      }
    }
    if (callback) callback();
  };

  const updateSegment = (updatedSegment) => {
    const clonedSegments = cloneDeep(segments);
    const updatedSegments = clonedSegments.map((segment) => {
      if (segment.segmentId === updatedSegment?.segmentId) {
        return workLogEdit
          ? {
              ...updatedSegment,
              event: {
                startTime:
                  updatedSegment?.startTime || updatedSegment?.event?.startTime,
                endTime:
                  updatedSegment?.endTime || updatedSegment?.event?.endTime
              }
            }
          : updatedSegment;
      }
      return segment;
    });
    // validateSegments(updatedSegments);
    // if (!isNotValid) {
    setSegments(updatedSegments);
    // }
  };

  const deleteSegment = (segmentId) => {
    setSegments(segments.filter((seg) => seg.segmentId !== segmentId));
    if (repositionPopup) {
      if (updateTimer) clearTimeout(updateTimer);
      updateTimer = setTimeout(() => {
        repositionPopup();
      }, 800);
    }
  };

  const isLoading =
    createWorklogLoading ||
    updateWorklogLoading ||
    deleteWorklogTimerEntryLoading;

  let timerDataChanged = !isEqual(
    pick(timer, [
      'notes',
      'billable',
      'type',
      'workItem',
      'serviceItem',
      'serviceCatalogItem'
    ]),
    {
      notes: comments,
      // segments: segments,
      billable: billable,
      type: 'MANUAL',
      workItem: workItem,
      serviceItem: selectedItem,
      serviceCatalogItem: selectedItem
    }
  );

  const { addedItems, deletedItems, updatedItems } = getParsedCrudData(
    props?.segments,
    segments,
    'segmentId'
  );

  if (addedItems.length || deletedItems.length || updatedItems.length) {
    timerDataChanged = true;
  }

  return (
    <Wrapper
      className={`p20 ${
        isLoading ? 'disabled pointer-events-none' : 'pointer-events-all'
      }`}
    >
      <span className="fx actr g10 timer-actions position-absolute">
        {!hideDelete && (timer?.timerId || timer?.itemId) && (
          <DeleteModal
            modalActivator={
              <span className="delete-timer ptr">
                <Tooltip
                  title={getTranslatedText(
                    intl,
                    workLogEdit
                      ? 'worklog.unknown.delete.title'
                      : 'timer.unknown.delete.title'
                  )}
                  position="right"
                  inertia
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                >
                  <SVGIcon name="Delete" size="sm" />
                </Tooltip>
              </span>
            }
            title={getTranslatedText(
              intl,
              workLogEdit
                ? 'worklog.unknown.delete.title'
                : 'timer.unknown.delete.title'
            )}
            handleDeleteConfirmation={() => {
              if (workLogEdit) {
                deleteWorklogEntry({
                  variables: {
                    deleteWorklogInput: {
                      itemId: timer?.itemId
                    }
                  }
                }).then((res) => {
                  resetWorklog();
                });
              } else {
                deleteWorklogTimerEntry({
                  variables: {
                    deleteWorklogTimerInput: {
                      timerId: timer?.timerId
                    }
                  }
                }).then((res) => {
                  resetWorklog();
                });
              }
            }}
            description={getTranslatedText(
              intl,
              workLogEdit
                ? 'worklog.unknown.delete.description'
                : 'timer.unknown.delete.description'
            )}
          />
        )}
        {!hideCancel && (
          <span className="close-popup ptr" onClick={handleClose}>
            <SVGIcon name="Close" size="sm" />
          </span>
        )}
      </span>
      <div className="flex col g10" style={{ gridTemplateColumns: '100%' }}>
        {hideWorkitem && !hideWorklogTask && (
          <WorklogTask
            task={associatedTaskToTimer}
            workItem={workItem}
            hideTaskWorkItem={hideTaskWorkItem}
            viewOnly={taskViewOnly}
          />
        )}

        <AccessControl
          productToCheck="MSP"
          render={
            <>
              {(workItem?.client?.accountId || workItem?.client?.name) && (
                <div className="flex center fg1">
                  <SVGIcon name="Cart" />
                  <DataGetter className="pl10 ml-10 br-5 fx fg1 timer-bg">
                    <Dropdown
                      className=""
                      classNamePrefix="value_selector"
                      formatGroupLabel={formatGroupLabel}
                      components={{ IndicatorSeparator, DropdownIndicator }}
                      title={getTranslatedText(
                        intl,
                        'admin.timeTracking.chooseDefaultTimerService'
                      )}
                      onChange={(val) => {
                        const selectedValue = {
                          ...omit(val, ['label', 'value'])
                        };
                        handlePropertyChange('timerItem', selectedValue);
                      }}
                      options={options}
                      placeholder={getTranslatedText(
                        intl,
                        'admin.timeTracking.chooseDefaultTimerService.placeholder'
                      )}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      closeMenuOnScroll={(e) => {
                        return (
                          e.target &&
                          e.target.classList &&
                          !(e.target.classList.value.indexOf('menu-list') > -1)
                        );
                      }}
                      value={
                        selectedItem
                          ? {
                              ...selectedItem,
                              label: selectedItem.name,
                              value: selectedItem.name
                            }
                          : null
                      }
                      name="valueselector"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      noOptionsMessage={() => {
                        return itemsForTimeTrackingLoading
                          ? 'Loading...'
                          : 'No options';
                      }}
                      isClearable={false}
                    />
                  </DataGetter>
                </div>
              )}
              {flags?.blockItemConsumptionInfo &&
                !hideBlockItemConsumptionInfo && (
                  <BlockItemConsumptionInfo
                    selectedItem={selectedItem}
                    ticket={workItem}
                    project={workItem}
                    endDateTime={
                      segments.length &&
                      (segments[segments.length - 1]?.event?.endTime ||
                        segments[segments.length - 1]?.endTime)
                    }
                    isAfterHours={false}
                  />
                )}
            </>
          }
        />
        <div className="flex center fg1">
          <span className="self-start  mt-8">
            <Avatar initials={`${currentUser.name[0]}`} size="extraSmall" />
          </span>
          <div className="w100">
            <DataGetter className="notes-editor pl10 ml-10 br-5 fx fg1 timer-bg">
              <TextField
                placeholder={getTranslatedText(
                  intl,
                  'workItem.details.add.note'
                )}
                multiline
                value={comments}
                onChange={(val) => {
                  handlePropChange('comments', val);
                }}
                error={errors?.notes?.[0]}
                onBlur={() => {
                  handlePropertyChange('comments', comments);
                }}
                autoComplete="off"
                maxLength={TEXT_LENGTH.size_9}
              />
            </DataGetter>

            {aiGeneratedNote && (
              <>
                <div className="flex g5 actr mt-10 ml-10">
                  <div className="flex ignoreOverride">
                    <SVGIcon name="AIWand" />
                  </div>
                  <div>
                    <TextStyle>
                      <FormattedMessage id="ai.generated.worklog.note" />
                    </TextStyle>
                  </div>
                  <div>
                    <Button
                      plain
                      onClick={() => {
                        if (setAIgeneratedNote) {
                          setAIgeneratedNote(false);
                        }
                        handlePropertyChange('comments', timerNote || '');
                      }}
                    >
                      <FormattedMessage id="ai.worklog.reset.selected.text" />
                    </Button>
                  </div>
                </div>
                <div className="p5 mb-14">
                  <AIOnboardingRatingComponent
                    nocomments
                    variant="transparent"
                    featureName={'WORKLOG_NOTE_COMPOSE'}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {isAgentChat && showAiNote && (
          <div className="flex actr g10 full-width">
            <SVGIcon name="AiSparkleOutline" color="#9A7BFF" />
            <TextStyle>
              <FormattedMessage id="ai.generated.worklog.note" />
            </TextStyle>
            <TextStyle>
              <Link
                onClick={() => {
                  handlePropertyChange('comments', '');
                  setShowAiNote(false);
                }}
              >
                <FormattedMessage id="common.clear" />
              </Link>
            </TextStyle>
          </div>
        )}
        {!hideWorkitem ? (
          associatedWorkItem || (!associatedWorkItem && associateWorkItem) ? (
            <>
              <AssociateWorkItem
                timer={timer}
                reAssociateWorkItem={
                  associatedTaskToTimer ? false : reAssociateWorkItem
                }
                associatedWorkItem={associatedWorkItem}
                handleAssociateWorkItem={handleAssociateWorkItem}
                handleParentClose={handleParentClose}
              />
              {!hideWorklogTask && (
                <div className="ml-30">
                  <WorklogTask
                    task={associatedTaskToTimer}
                    workItem={workItem}
                    hideTaskWorkItem={hideTaskWorkItem}
                    viewOnly={taskViewOnly}
                  />
                </div>
              )}
            </>
          ) : null
        ) : null}
        {segments.length ? (
          <Segments
            intl={intl}
            segments={segments}
            addSegment={addSegment}
            updateSegment={updateSegment}
            deleteSegment={deleteSegment}
            errors={errors?.segments?.[0]?.errors}
            hideAfterHours={workLogEdit}
            isAgentChat={isAgentChat}
          />
        ) : null}
        <div className="flex center ">
          <ButtonGroup>
            {worklogAdd ? (
              <Button
                loading={
                  createWorklogEntryFromTimerLoading ||
                  addWorklogLoading ||
                  createWorklogLoading ||
                  updateWorklogLoading
                }
                disabled={!workItem?.workId}
                onClick={handleAddWorklog}
                plain
              >
                <FormattedMessage
                  id={
                    workLogEdit
                      ? 'ticket.details.worklog.manual.update'
                      : 'workItem.details.worklog.timer.addAsWorklog'
                  }
                />
              </Button>
            ) : workItem?.workId || workLogEdit ? (
              <Button
                loading={
                  createWorklogEntryFromTimerLoading ||
                  addWorklogLoading ||
                  createWorklogLoading ||
                  updateWorklogLoading
                }
                onClick={handleAddWorklog}
                plain
              >
                <FormattedMessage
                  id={
                    workLogEdit
                      ? 'ticket.details.worklog.manual.update'
                      : 'workItem.details.worklog.timer.addAsWorklog'
                  }
                />
              </Button>
            ) : null}
            {!disableSaveTimer && (
              <ButtonGroup>
                {worklogAdd
                  ? null
                  : !workLogEdit &&
                    timerDataChanged && (
                      <Button
                        plain
                        loading={
                          createWorklogTimerEntryLoading ||
                          updateWorklogTimerEntryLoading ||
                          deleteWorklogTimerEntryLoading
                        }
                        onClick={handleTimerClick}
                      >
                        <FormattedMessage
                          id={
                            timer?.timerId
                              ? 'ticket.details.worklog.manual.update'
                              : 'ticket.details.worklog.manual.save'
                          }
                        />
                      </Button>
                    )}
                {!workLogEdit && !timer?.timerId && (
                  <Button
                    onClick={() => {
                      resetWorklogEntry();
                      if (closeOnCancel) closeOnCancel();
                      if (repositionPopup) {
                        if (updateTimer) clearTimeout(updateTimer);
                        updateTimer = setTimeout(() => {
                          repositionPopup();
                        }, 800);
                      }
                    }}
                    plainSecondary
                  >
                    <FormattedMessage id="ticket.details.worklog.timer.cancel" />
                  </Button>
                )}
              </ButtonGroup>
            )}
          </ButtonGroup>
          <AccessControl
            productToCheck={COMMON_CONSTANTS.MSP}
            render={
              <div className="mlauto flex g10 center">
                <Tooltip
                  title={getTranslatedText(
                    intl,
                    billable
                      ? 'worklog.details.markedAsBillable'
                      : 'worklog.details.markAsBillable'
                  )}
                  position="top-start"
                  inertia
                  className="full-width"
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                >
                  <IconHolder
                    selected={billable}
                    className="mlauto border-black br-5"
                    onClick={handleBillable}
                    padding="3px"
                    size="24px"
                    iconsize="16px"
                  >
                    <SVGIcon name="Billable" />
                  </IconHolder>
                </Tooltip>

                {workLogEdit && (
                  <Tooltip
                    title={getTranslatedText(
                      intl,
                      afterHours
                        ? 'worklog.details.markedAsAfterhours'
                        : 'worklog.details.markAsAfterhours'
                    )}
                    position="top-start"
                    inertia
                    className="full-width"
                    trigger="mouseenter"
                    animation="shift"
                    animateFill={false}
                  >
                    <IconHolder
                      selected={afterHours}
                      className="mlauto border-black br50pt"
                      onClick={() => {
                        handlePropertyChange('afterHours', !afterHours);
                      }}
                      padding="3px"
                      size="24px"
                      iconsize="16px"
                    >
                      <SVGIcon name="AfterHours" />
                    </IconHolder>
                  </Tooltip>
                )}
              </div>
            }
          />
        </div>
      </div>
    </Wrapper>
  );
}

const Segments = (props) => {
  const {
    intl,
    segments,
    deleteSegment,
    addSegment,
    updateSegment,
    errors,
    hideAfterHours,
    isAgentChat
  } = props;
  const segmentsContainerRef = useRef();

  const segmentDateMapRef = useRef({});

  function handleAddSegment(date) {
    addSegment(
      // callback function
      () => {
        // segmentDateMapRef.current = {
        //   ...segmentDateMapRef.current,
        //   [newSegment?.segmentId]: dayjs(date).format(DATE_FORMAT)
        // };
        setTimeout(() => {
          if (segments.length) {
            const containerBottom = segmentsContainerRef.current?.getBoundingClientRect()
              ?.bottom;
            segmentsContainerRef.current.scrollTo(0, containerBottom || 0);
          }
        }, 500);
      }
    );
  }

  function handleDeleteSegment(segment) {
    return () => {
      deleteSegment(segment?.segmentId);
      if (segmentDateMapRef.current[segment?.segmentId]) {
        delete segmentDateMapRef.current[segment.segmentId];
      }
    };
  }

  return (
    <div className="mb5">
      <div
        ref={segmentsContainerRef}
        className="scroll scroll-smooth max-height-view-350"
      >
        {segments.map((segment, idx) => {
          const segmentStartTime =
            segment?.startTime || segment?.event?.startTime;
          const segmentEndTime = segment?.endTime || segment?.event?.endTime;
          const dateToPopulate = segmentStartTime || segmentEndTime;

          if (dateToPopulate) {
            segmentDateMapRef.current = {
              ...segmentDateMapRef.current,
              [segment.segmentId]: dateToPopulate || null
            };
          }

          return (
            <div className="mb5" key={segment?.segmentId}>
              <Segment
                intl={intl}
                segment={{
                  ...segment,
                  segmentDate:
                    segmentDateMapRef.current?.[segment?.segmentId] || null
                }}
                setSegmentDate={(selectedDate) => {
                  segmentDateMapRef.current = {
                    ...segmentDateMapRef.current,
                    [segment.segmentId]: selectedDate
                  };
                }}
                addSegment={handleAddSegment}
                isAgentChat={isAgentChat}
                updateSegment={updateSegment}
                showDeleteSegment={segments?.length > 1}
                deleteSegment={handleDeleteSegment(segment)}
                hideAfterHours={hideAfterHours}
              />
              {errors?.[idx]?.error &&
                reactSelectInlineError(
                  getTranslatedText(intl, 'worklog.manual.segment.invalid')
                )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Segment = (props) => {
  const {
    intl,
    segment,
    addSegment,
    showDeleteSegment,
    deleteSegment,
    updateSegment,
    hideAfterHours,
    setSegmentDate,
    isAgentChat
  } = props;

  const { timespent, afterHours, segmentDate } = segment;
  const appContext = useContext(AppContext);
  const { dateFormat, timeFormat } = appContext?.companyInfo;

  const segmentStartTime = segment?.startTime || segment?.event?.startTime;
  const segmentEndTime = segment?.endTime || segment?.event?.endTime;

  // const [segmentDate, setSegmentDate] = useState(
  //   dateToPopulate ? dayjs(dateToPopulate).format(DATE_FORMAT) : null
  // );

  function isTimeSpentValid(timeSpent) {
    return timeSpent >= 0;
  }

  function handleDateChange(date) {
    setSegmentDate(dayjs(date).format(DATE_FORMAT));
    const updatedSegment = {
      ...segment
    };
    if (segmentStartTime) {
      updatedSegment.startTime = dayjs(segmentStartTime)
        .set('date', date.getDate())
        .set('months', date.getMonth())
        .set('year', date.getFullYear())
        .format(DATE_TIME_FORMAT);
    }
    if (segmentEndTime) {
      updatedSegment.endTime = dayjs(segmentEndTime)
        .set('date', date.getDate())
        .set('months', date.getMonth())
        .set('year', date.getFullYear())
        .format(DATE_TIME_FORMAT);
    }
    updateSegment(updatedSegment);
  }

  const handlePropChange = (field, time) => {
    let segmentNewData;
    switch (field) {
      case 'startTime':
        segmentNewData = {
          ...segment,
          timespent: segmentEndTime
            ? dayjs(segmentEndTime).diff(dayjs(time)) < 1
              ? 1
              : dayjs(segmentEndTime).diff(dayjs(time)) / (1000 * 60)
            : segment?.timespent || null,
          startTime: time
        };
        break;
      case 'timespentMinutes':
        if (segmentStartTime && !segmentEndTime) {
          const updatedEndTime = dayjs(segmentStartTime)
            .add(time, 'minutes')
            .format(DATE_TIME_FORMAT);
          if (dayjs(segmentStartTime).isSame(updatedEndTime, 'date')) {
            segmentNewData = {
              ...segment,
              timespent: Number(time),
              endTime: updatedEndTime
            };
          }
        } else {
          const updatedStartTime = dayjs(segmentEndTime)
            .subtract(time, 'minutes')
            .format(DATE_TIME_FORMAT);
          if (dayjs(updatedStartTime).isSame(segmentEndTime, 'date')) {
            segmentNewData = {
              ...segment,
              timespent: Number(time),
              startTime: updatedStartTime
            };
          }
        }
        break;
      default:
        segmentNewData = {
          ...segment,
          timespent: segmentStartTime
            ? dayjs(time).diff(dayjs(segmentStartTime), 'minutes')
            : segment?.timespent || null,
          [field]: time
        };
        break;
    }
    if (
      !segmentNewData.timespent ||
      isTimeSpentValid(segmentNewData.timespent)
    ) {
      updateSegment(segmentNewData);
    }
  };

  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => {
        const isSmallerScreen = size?.width < 350;
        const isSmallestScreen = size?.width < 325;
        const isDurationDisabled =
          !segmentDate ||
          (isEmpty(segmentEndTime) && isEmpty(segmentStartTime));

        return (
          <div className="fx g5">
            <div className="flex center relative wrap g5">
              <div className="flex fjc-start fg1 g5">
                <div className="fx col">
                  <div className="flex center fg1 g10">
                    <div className="min-width-20 flex center">
                      <SVGIcon name="EstimatedTime" />
                    </div>
                    <div
                      className={`fx actr wrap card-surface-bg br-5 p5 min-w80 ${
                        isDurationDisabled ? 'disabled' : ''
                      }`}
                    >
                      <Tooltip
                        title={getTranslatedText(
                          intl,
                          segmentDate
                            ? isEmpty(segmentEndTime) &&
                              isEmpty(segmentStartTime)
                              ? 'workItem.choose.start.or.end.time'
                              : 'attribute.duration'
                            : 'common.chooseDate'
                        )}
                        position="top"
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                      >
                        <DurationDropdown
                          disabled={isDurationDisabled}
                          date={segmentDate}
                          duration={timespent}
                          endTime={segmentEndTime}
                          startTime={segmentStartTime}
                          onChange={(val) => {
                            handlePropChange('timespentMinutes', val);
                          }}
                        />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div className="fx col">
                  <DateWrapper className="flex relative br-5 actr g5">
                    {!isSmallerScreen && (
                      <div className="min-width-20 flex pl5 center">
                        <SVGIcon name="Worklog" />
                      </div>
                    )}
                    <div
                      className={`fx actr card-surface-bg br-5 p5 ${
                        isSmallestScreen ? 'w70px' : 'w80px'
                      } ${!segmentDate ? 'disabled' : ''}`}
                    >
                      <Tooltip
                        title={getTranslatedText(
                          intl,
                          segmentDate
                            ? 'workItem.start.time'
                            : 'common.chooseDate'
                        )}
                        position="top"
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                      >
                        <TimeSelectionDropdown
                          timeFormat={timeFormat}
                          key={segmentStartTime || 'segmentStartTime'}
                          placeholderText={getTranslatedText(
                            intl,
                            'workItem.start.time'
                          )}
                          endTime={segmentEndTime}
                          value={
                            segmentStartTime
                              ? dayjs(segmentStartTime).toDate()
                              : null
                          }
                          date={segmentDate}
                          onChange={(value) => {
                            const date = segmentDate || new Date();
                            const selectedTime = dayjs(date)
                              .set('hours', dayjs(value).hour())
                              .set('minutes', dayjs(value).minute())
                              .format(DATE_TIME_FORMAT);
                            handlePropChange('startTime', selectedTime);
                          }}
                          maxTime={segmentEndTime || null}
                          disabled={!segmentDate}
                        />
                      </Tooltip>
                    </div>
                    {!isSmallerScreen && (
                      <div className="tcenter min-width-20">-</div>
                    )}
                    <div
                      className={`fx actr card-surface-bg br-5 p5  ${
                        isSmallestScreen ? 'w70px' : 'w80px'
                      } ${!segmentDate ? 'disabled' : ''}`}
                    >
                      <Tooltip
                        title={getTranslatedText(
                          intl,
                          segmentDate
                            ? 'workItem.end.time'
                            : 'common.chooseDate'
                        )}
                        position="top"
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                      >
                        <TimeSelectionDropdown
                          timeFormat={timeFormat}
                          key={segmentEndTime || 'segmentEndTime'}
                          placeholderText={getTranslatedText(
                            intl,
                            'workItem.end.time'
                          )}
                          startTime={segmentStartTime}
                          value={
                            segmentEndTime
                              ? dayjs(segmentEndTime).toDate()
                              : null
                          }
                          onChange={(value) => {
                            const date = segmentDate || new Date();
                            const selectedTime = dayjs(date)
                              .set('hours', dayjs(value).hour())
                              .set('minutes', dayjs(value).minute())
                              .format(DATE_TIME_FORMAT);
                            handlePropChange(
                              'endTime',
                              segmentStartTime &&
                                dayjs(selectedTime).diff(
                                  dayjs(segmentStartTime)
                                ) < 1
                                ? dayjs(segmentStartTime)
                                    .add(1, 'minute')
                                    .format(DATE_TIME_FORMAT)
                                : selectedTime
                            );
                          }}
                          date={segmentDate}
                          minTime={segmentStartTime || null}
                          disabled={!segmentDate}
                        />
                      </Tooltip>
                    </div>
                  </DateWrapper>
                </div>
              </div>
              <div className="flex fjc-start fg1 g5 wrap">
                <div className="f-12 linkText">
                  <Tooltip
                    title={getTranslatedText(intl, 'common.chooseDate')}
                    position="top"
                    inertia
                    trigger="mouseenter"
                    animation="shift"
                    animateFill={false}
                  >
                    <DateTimePicker
                      selected={
                        segmentDate ? dayjs(segmentDate).toDate() : null
                      }
                      onChange={handleDateChange}
                      placeholderText={'Segment Date'}
                      // dateFormat={DATE_FORMAT.toLowerCase()}
                      required
                      disabled={false}
                      minDate={null}
                      popperPlacement="auto"
                      portalId="root-portal"
                      customInput={<CustomDatePickerInput />}
                    />
                  </Tooltip>
                </div>
                {!hideAfterHours && (
                  <span
                    onClick={() => {
                      updateSegment({
                        ...segment,
                        afterHours: !afterHours
                      });
                    }}
                    className={`fx actr g5 ptr ${
                      isSmallerScreen ? 'ml-30' : 'mlauto'
                    }`}
                  >
                    <Checkbox
                      label={getTranslatedText(
                        intl,
                        'worklog.details.markAsAfterhours'
                      )}
                      labelHidden
                      checked={afterHours}
                    />
                    <DisplayText>
                      <TextStyle variation="subdued">
                        <FormattedMessage id="worklog.details.markAsAfterhours" />
                      </TextStyle>
                    </DisplayText>
                  </span>
                )}
              </div>
            </div>
            {!isAgentChat && (
              <span
                className={`fx col g5 ${!showDeleteSegment ? 'mt-15' : ''}`}
              >
                {/* <span className="fx actr ptr">
                <DateTimePicker
                  selected={segmentDate ? dayjs(segmentDate).toDate() : null}
                  onChange={addSegment}
                  placeholderText={'Segment Date'}
                  dateFormat={dateFormat.toLowerCase().replaceAll('m', 'M')}
                  required
                  disabled={false}
                  minDate={null}
                  popperPlacement="auto"
                  portalId="root-portal"
                  customInput={
                    <CustomDatePickerAddSegement
                      isSmallerScreen={isSmallerScreen}
                    />
                  }
                />
              </span> */}
                <span onClick={addSegment} className="fx actr ptr">
                  <SVGIcon
                    name="CirclePlus"
                    size={isSmallerScreen ? 'sm' : 'md'}
                    color="#8CBE62"
                  />
                </span>
                {showDeleteSegment && (
                  <span onClick={deleteSegment} className="fx actr ptr">
                    <SVGIcon
                      name="CircleMinus"
                      size={isSmallerScreen ? 'sm' : 'md'}
                      color="#C14136"
                    />
                  </span>
                )}
              </span>
            )}
          </div>
        );
      }}
    </SizeMe>
  );
};

export default injectIntl(WorklogManualTimerForm);

const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => {
  const intl = useIntl();

  const appContext = useContext(AppContext);
  const { dateFormat } = appContext?.companyInfo;

  const isToday = dayjs(value).isSame(new Date(), 'day');

  const formattedDate = dayjs(value).format(dateFormat);

  return (
    <span className="white-bg ml-30" onClick={onClick} ref={ref}>
      {value ? formattedDate : getTranslatedText(intl, 'common.chooseDate')}
      {isToday ? `(${getTranslatedText(intl, 'placeholder.today')})` : null}
    </span>
  );
});

// const CustomDatePickerAddSegement = forwardRef(
//   ({ onClick, isSmallerScreen }, ref) => {
//     return (
//       <span onClick={onClick} ref={ref}>
//         <SVGIcon
//           name="CirclePlus"
//           size={isSmallerScreen ? 'sm' : 'md'}
//           color="#8CBE62"
//         />
//       </span>
//     );
//   }
// );
